export const CARTEVITALE_LESSONS_PT = [
  {
    id: 'cartevitale-1',
    numero: 1,
    titre: "Compreender o seu cartão Vitale",
    sousTitre: "O que é e como funciona?",
    contexte: "O cartão Vitale é o seu cartão de saúde francês. Eis tudo o que precisa de saber para o utilizar correctamente.",
    explication: [
      "**O cartão Vitale** comprova os seus direitos ao seguro de saúde. Apresente-o a cada médico ou farmacêutico para facilitar o reembolso.",
      "**O número de segurança social** tem 15 dígitos e está impresso no cartão. É o seu identificador único no sistema de saúde.",
      "**Em caso de perda**: ligue para o 36 46 (gratuito a partir de linha fixa) ou peça um novo cartão em ameli.fr.",
      "**O cartão não tem prazo de validade** — permanece válido enquanto estiver segurado. Mas deve ser actualizado a cada alteração da sua situação.",
      "**Se se esquecer do cartão**: o médico pode introduzir o seu número manualmente. Na farmácia, guarde a receita, pague e depois reembolse.",
    ],
    question: "Qual o número a ligar em caso de perda do cartão Vitale?",
    options: [
      { id: 'a', text: "36 46", correct: true },
      { id: 'b', text: "15", correct: false },
      { id: 'c', text: "3230", correct: false },
    ],
    explication_reponse: "O 36 46 é o número Ameli para os segurados. Gratuito a partir de linha fixa. Pode também pedir um novo cartão directamente em ameli.fr na secção 'Os meus serviços'.",
  },
  {
    id: 'cartevitale-2',
    numero: 2,
    titre: "Criar e utilizar o espaço Ameli",
    sousTitre: "O seu espaço de saúde pessoal",
    contexte: "ameli.fr é o seu site para gerir tudo o que diz respeito ao seu seguro de saúde. Veja como criar a sua conta.",
    explication: [
      "**Crie a sua conta** em ameli.fr → 'Criar a minha conta'. Vai precisar de: número de segurança social, data de nascimento, endereço de email.",
      "**O que pode fazer**: verificar os seus direitos, descarregar o comprovativo de direitos, consultar os reembolsos, pedir um novo cartão Vitale.",
      "**O comprovativo de direitos** comprova o seu seguro de saúde — pedido por médicos, hospitais e farmácias. Descarregável em 30 segundos.",
      "**A aplicação Ameli**: os mesmos serviços no telemóvel — rápido e conveniente para saber o estado dos reembolsos a qualquer momento.",
      "**A mensagem online**: envie questões directamente à Assurance Maladie sem esperar ao telefone.",
    ],
    question: "Onde encontrar rapidamente o seu comprovativo de direitos de saúde?",
    options: [
      { id: 'a', text: "Em ameli.fr no seu espaço pessoal — em 30 segundos", correct: true },
      { id: 'b', text: "Deslocando-se à CPAM com documento de identidade", correct: false },
      { id: 'c', text: "Ligando para o 36 46 e aguardando carta", correct: false },
    ],
    explication_reponse: "O comprovativo de direitos está disponível imediatamente em ameli.fr ou na aplicação — 24h/24. É um dos documentos mais pedidos por médicos e hospitais.",
  },
  {
    id: 'cartevitale-3',
    numero: 3,
    titre: "Actualizar o seu cartão Vitale",
    sousTitre: "Quando e como?",
    contexte: "O cartão Vitale precisa de actualizações regulares para reflectir a sua situação real. Veja quando e como fazê-lo.",
    explication: [
      "**Actualização na farmácia**: introduza o cartão na máquina verde (borne de mise à jour) existente na maioria das farmácias. Gratuito e rápido.",
      "**Quando actualizar?** Após um nascimento, casamento, divórcio, alteração de situação profissional, ou anualmente para manter os dados actualizados.",
      "**O cartão digital Ameli**: pode usar a aplicação Ameli como cartão digital no telemóvel — aceite pela maioria dos profissionais de saúde.",
      "**Em caso de mudança de médico de família**: deve actualizar o cartão na farmácia após o registo no novo médico.",
      "**Não se preocupe se se esquecer**: o médico pode sempre introduzir o número manualmente — a actualização é importante para beneficiar plenamente dos seus direitos.",
    ],
    question: "Onde pode actualizar o cartão Vitale gratuitamente?",
    options: [
      { id: 'a', text: "Na máquina verde da farmácia", correct: true },
      { id: 'b', text: "Apenas no escritório da CPAM", correct: false },
      { id: 'c', text: "Apenas no médico de família", correct: false },
    ],
    explication_reponse: "A máquina verde existe na maioria das farmácias — gratuito e rápido. Introduza o cartão e aguarde 30 segundos. Pode também usar a aplicação como alternativa digital.",
  },
  {
    id: 'cartevitale-4',
    numero: 4,
    titre: "Compreender os seus reembolsos",
    sousTitre: "Quem paga o quê?",
    contexte: "Foi ao médico e pagou. Quanto vai receber de volta? Como funciona o sistema de reembolso?",
    explication: [
      "**O reembolso base**: a Segurança Social reembolsa normalmente 70% da tarifa oficial. Os 30% restantes chamam-se 'ticket moderador'.",
      "**O médico de família**: se tiver um médico de família declarado, beneficia do melhor reembolso. Sem ele, a parte não reembolsada duplica.",
      "**O percurso de cuidados coordenado**: passe sempre pelo médico de família antes de consultar um especialista — caso contrário os reembolsos são reduzidos.",
      "**CSS (Cobertura de Saúde Complementar)**: se o seu rendimento for limitado, pode obter CSS gratuitamente — cobre o que a Segurança Social não reembolsa.",
      "**Prazo de reembolso**: normalmente 5 a 7 dias úteis após a consulta, directamente na sua conta bancária.",
    ],
    question: "Qual a percentagem de reembolso base da Segurança Social numa consulta ao médico de família?",
    options: [
      { id: 'a', text: "70% da tarifa oficial", correct: true },
      { id: 'b', text: "100% sempre", correct: false },
      { id: 'c', text: "Apenas 50%", correct: false },
    ],
    explication_reponse: "A Segurança Social reembolsa 70% para o médico de família. Os 30% restantes podem ser cobertos por um seguro complementar (mutuelle) ou pela CSS se tiver direito.",
  },
];
